import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 flex-wrap gap-10" }
const _hoisted_4 = { class: "d-flex align-items-center flex-wrap gap-10" }
const _hoisted_5 = {
  class: "position-relative",
  style: {"min-width":"220px","max-width":"300px"}
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = {
  key: 0,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#companyModal",
  style: {"background-color":"#EB9355"}
}
const _hoisted_9 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_13 = {
  key: 0,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_15 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_16 = {
  key: 1,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_17 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_18 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_19 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_22 = {
  key: 1,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_23 = {
  key: 2,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_24 = {
  key: 3,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_26 = {
  key: 4,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_27 = {
  key: 5,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_31 = {
  key: 0,
  class: "badge text-outline-info"
}
const _hoisted_32 = {
  key: 1,
  class: "badge text-outline-success"
}
const _hoisted_33 = {
  key: 2,
  class: "badge text-outline-danger"
}
const _hoisted_34 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 2 }
const _hoisted_39 = { class: "dropdown-item text-muted" }
const _hoisted_40 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_41 = {
  key: 0,
  class: "mb-0 text-paragraph"
}
const _hoisted_42 = { class: "fw-bold" }
const _hoisted_43 = { class: "fw-bold" }
const _hoisted_44 = {
  key: 1,
  class: "mb-0 text-paragraph"
}
const _hoisted_45 = { class: "fw-bold" }
const _hoisted_46 = { class: "fw-bold" }
const _hoisted_47 = { class: "mt-15 mt-md-0" }
const _hoisted_48 = { class: "pagination mb-0" }
const _hoisted_49 = {
  key: 0,
  class: "page-item"
}
const _hoisted_50 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 1,
  class: "page-item"
}
const _hoisted_53 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_54 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_55 = { class: "modal-content" }
const _hoisted_56 = { class: "modal-header" }
const _hoisted_57 = { class: "modal-title fs-5" }
const _hoisted_58 = { class: "modal-body" }
const _hoisted_59 = { style: {"margin-bottom":"5%"} }
const _hoisted_60 = { class: "text-black fw-bold mb-0 text-center" }
const _hoisted_61 = {
  class: "text-black fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_62 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_63 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_64 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_65 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_66 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_67 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "col-md-6" }
const _hoisted_70 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_71 = { value: "" }
const _hoisted_72 = { value: "BANK" }
const _hoisted_73 = { value: "CRYPTO" }
const _hoisted_74 = { class: "col-md-6" }
const _hoisted_75 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_76 = { class: "invalid-feedback" }
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col-md-12" }
const _hoisted_79 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_80 = ["placeholder"]
const _hoisted_81 = { class: "invalid-feedback" }
const _hoisted_82 = { class: "modal-footer" }
const _hoisted_83 = {
  key: 0,
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}

import { ref, reactive, computed, watch, onMounted, onBeforeUnmount, inject } from "vue";
import axios from 'axios';
import router from '../../router/index'
import { useI18n } from "vue-i18n";
import * as yup from 'yup';
import { Country, Fee, Operator, Organization, TypeFree, Repayment, User } from "@/utils/Model";
import { getTypeFee } from "../../utils/services";
import { current_permissions } from '../../utils/permission';
import { showToast, validate_phone_number, checkSessionValidate, formatNumber } from "@/utils/function";
const MENU_WIDTH = 180;


export default /*@__PURE__*/_defineComponent({
  __name: 'RepaymentContent',
  setup(__props) {

const backApi = inject('back');

const { locale, t } = useI18n();
const selectedOrganization = ref('');
const selectedOperator = ref('');
const selectedCountry = ref('');
const selectedType = ref('');
const selectedMode = ref('');

const loader = ref(false);

let token: string | null = localStorage.getItem('login_token');
let codeOrganization: string | null = localStorage.getItem('organization_code');
let codeUser: string | null = localStorage.getItem('code');
let role: string | null = localStorage.getItem('role');

const countries = ref(new Array<Country>());
const allRepayments = ref(new Array<Repayment>());

const typeLabelOf = (type: string) =>
  type === 'BANK' ? t('repayments.bankAccount')
    : type === 'CRYPTO' ? t('repayments.cryptoAccount')
    : type === 'PAYOUT' ? t('repayments.payoutAccount')
    : '';

const statusLabelOf = (status: string) =>
  status === 'DRAFT' ? t('repayments.pending')
    : status === 'VALIDATED' ? t('repayments.validated')
    : status === 'REJECTED' ? t('repayments.rejected')
    : '';

const searchQuery = ref('');
const page = ref(1);
const pageSize = ref(15);

// Filtrage front sur les mêmes colonnes que le tableau affiché.
const filteredRepayments = computed(() => {
  const q = searchQuery.value.trim().toLowerCase();
  if (!q) return allRepayments.value;
  return allRepayments.value.filter((r: any) => {
    const values = [
      r.code,
      r.organization?.name,
      typeLabelOf(r.type),
      r.createdBy?.name,
      r.validatedBy?.name,
      r.amount,
      r.totalFees,
      statusLabelOf(r.status),
    ];
    return values.some(v => (v ?? '').toString().toLowerCase().includes(q));
  });
});

const filteredTotal = computed(() => filteredRepayments.value.length);
const numPages = computed(() => Math.max(1, Math.ceil(filteredTotal.value / pageSize.value)));

const showingFrom = computed(() => filteredTotal.value === 0 ? 0 : (page.value - 1) * pageSize.value + 1);
const showingTo = computed(() => Math.min(page.value * pageSize.value, filteredTotal.value));

const repayments = computed(() => {
  const start = (page.value - 1) * pageSize.value;
  return filteredRepayments.value.slice(start, start + pageSize.value);
});

let user = {} as User;
const operators = ref(new Array<Operator>());
const collectBalance = ref(0);
let balance: number = 0;
const typefees = ref(new Array<TypeFree>());
let operatorsTemp = new Array<Operator>();
let countriesTemp = new Array<Country>();
let data: any[] = [];

const errors = ref('');
const errorId = ref('');
const success = ref('');
const errorsBis = { 'amount': '', 'description': '' };
const pageLoad = ref(false);

const formValues = reactive({
  amount: "",
  description: ""
});

const schema = yup.object({
  amount: yup.number().required('Le montant est requis'),
  description: yup.string().required('La description est requise'),
});

const openMenuCode = ref<string | null>(null);
const currentRepayment = ref<any>(null);
const menuPosition = reactive({ top: 0, left: 0 });
function toggleActionsMenu(repayment: any, event: MouseEvent) {
  if (openMenuCode.value === repayment.code) {
    closeActionsMenu();
    return;
  }
  const button = event.currentTarget as HTMLElement;
  const rect = button.getBoundingClientRect();

  let left = rect.right - MENU_WIDTH;
  if (left < 8) left = 8;

  menuPosition.top = rect.bottom + 4;
  menuPosition.left = left;

  currentRepayment.value = repayment;
  openMenuCode.value = repayment.code;
}

function closeActionsMenu() {
  openMenuCode.value = null;
  currentRepayment.value = null;
}

function onActionClick(status: string) {
  if (currentRepayment.value) {
    changeStatus(status, currentRepayment.value.code);
  }
  closeActionsMenu();
}

function handleDocumentClick(event: MouseEvent) {
  const target = event.target as HTMLElement;
  if (!target.closest('.custom-actions-menu') && !target.closest('.dropdown-toggle')) {
    closeActionsMenu();
  }
}

function handleScrollOrResize() {
  closeActionsMenu();
}

function handleAmountChange(event) {
  let withdrawAmount = event.target.value;
  if (parseFloat(withdrawAmount) <= 0) {
    showToast("Veuillez saisir un montant correct", "red");
    formValues.amount = ''
  }
  if (parseFloat(withdrawAmount) > balance) {
    showToast("Solde insuffisant pour cette opération", "red");
    formValues.amount = ''
  }
}

function handleOperatorChange(event) {
  selectedOperator.value = event.target.value;
}

function handleTypeChange(event) {
  selectedType.value = event.target.value;
}

function handleModeChange(event) {
  selectedMode.value = event.target.value;
}

function formatDateFr(value) {
  if (value) {
    const year = value.getFullYear();
    let month = value.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = value.getDate();
    day = day < 10 ? '0' + day : day;
    return day + '/' + month + '/' + year;
  }
}

// Récupère une page depuis l'API (nouvelle forme { data, pagination })
const fetchRepaymentsPage = (targetPage: number) => {
  let baseUrl = '';
  if (
    role === 'SUPERADMIN' ||
    role === 'BUSINESS' ||
    role === 'SUPPORT'
  ) {
    baseUrl = backApi + '/secure/repayments/extended';
  } else {
    baseUrl = backApi + '/secure/repayments/';
  }
  const separator = baseUrl.includes('?') ? '&' : '?';
  const url = `${baseUrl}${separator}page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}

const loadAllRepayments = async () => {
  try {
    const first = await fetchRepaymentsPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchRepaymentsPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    allRepayments.value = collected;
    data = collected;
    page.value = 1;
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const goToPage = (targetPage: number) => {
  if (targetPage < 1 || targetPage > numPages.value || targetPage === page.value) return;
  page.value = targetPage;
}

watch(searchQuery, () => {
  page.value = 1;
});

const getBalanceCollect = () => {
  axios.post(backApi + `/secure/accounts/balance/available`, {
    organization: codeOrganization,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      collectBalance.value = formatNumber(parseInt(response.data.balance));
      balance = response.data.balance;
      console.log(response.data);
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const changeStatus = (status, code) => {
  axios.put(`${backApi}/secure/repayments/status`, {
    code: code,
    status: status
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    router.go();
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const storeRepayment = () => {
  try {
    schema.validateSync(formValues);
    axios.post(`${backApi}/secure/repayments/new`, {
      amount: parseFloat(formValues.amount),
      description: formValues.description,
      organization: codeOrganization,
      type: selectedType.value
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        router.go();
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

const exportExcel = () => {
  import("../../utils/Export2Excel").then((excel) => {
    const Header = ["CODE REVERSEMENT", "TYPE", "MONTANT", "TOTAL FRAIS", "DATE", "STATUT"];
    const Fields = ["code", "type", "amount", "totalFees", "createdAt", "status"];
    const dataForExcel = formatJSon(Fields, data);
    excel.export_json_to_excel({
      header: Header,
      data: dataForExcel,
      sheetName: "Feuil1",
      filename: "reversements",
      autoWidth: true,
      bookType: "xlsx",
    });
  });
}

function formatJSon(FilterData, JsonData) {
  return JsonData.map((v) => FilterData.map(j => {
    return v[j];
  }));
}

onMounted(async () => {
  checkSessionValidate(1);
  loadAllRepayments();
  getBalanceCollect();

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000)

  document.addEventListener('click', handleDocumentClick);
  window.addEventListener('scroll', handleScrollOrResize, true);
  window.addEventListener('resize', handleScrollOrResize);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleDocumentClick);
  window.removeEventListener('scroll', handleScrollOrResize, true);
  window.removeEventListener('resize', handleScrollOrResize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_unref(current_permissions)('export_transactions'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-outline-btn text-black bg-transparent position-relative transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block",
                    type: "button",
                    onClick: exportExcel
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('repayments.excel')) + " ", 1),
                    _cache[11] || (_cache[11] = _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" }, null, -1))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                  type: "text",
                  class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                  placeholder: _ctx.$t('repayments.search')
                }, null, 8, _hoisted_6), [
                  [_vModelText, searchQuery.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_unref(current_permissions)('create_repayment'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.$t('repayments.createRequest')) + " ", 1),
                    _cache[12] || (_cache[12] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("table", _hoisted_11, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('repayments.code')), 1),
                    (_unref(current_permissions)('SUPERADMIN'))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_13, _toDisplayString(_ctx.$t('repayments.organization')), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('repayments.type')), 1),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('repayments.initiatedBy')), 1),
                    (_unref(current_permissions)('SUPERADMIN'))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_16, _toDisplayString(_ctx.$t('repayments.validatedBy')), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('repayments.amount')), 1),
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('repayments.totalFees')), 1),
                    _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('repayments.status')), 1),
                    _cache[13] || (_cache[13] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repayments.value, (repayment) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: repayment.code
                    }, [
                      _createElementVNode("td", _hoisted_20, _toDisplayString(repayment.code), 1),
                      (_unref(current_permissions)('SUPERADMIN'))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(repayment.organization?.name), 1))
                        : _createCommentVNode("", true),
                      (repayment.type==='BANK')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString(_ctx.$t('repayments.bankAccount')), 1))
                        : _createCommentVNode("", true),
                      (repayment.type==='CRYPTO')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(_ctx.$t('repayments.cryptoAccount')), 1))
                        : _createCommentVNode("", true),
                      (repayment.type==='PAYOUT')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_24, _toDisplayString(_ctx.$t('repayments.payoutAccount')), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(repayment.createdBy?.name), 1),
                      (_unref(current_permissions)('SUPERADMIN') && repayment.validatedBy!==null)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_26, _toDisplayString(repayment.validatedBy?.name), 1))
                        : _createCommentVNode("", true),
                      (_unref(current_permissions)('SUPERADMIN') && repayment.validatedBy===null)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_27, _toDisplayString('')))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(repayment.amount), 1),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(repayment.totalFees), 1),
                      _createElementVNode("td", _hoisted_30, [
                        (repayment.status==='DRAFT')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t('repayments.pending')), 1))
                          : _createCommentVNode("", true),
                        (repayment.status==='VALIDATED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t('repayments.validated')), 1))
                          : _createCommentVNode("", true),
                        (repayment.status==='REJECTED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$t('repayments.rejected')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_34, [
                        (repayment.status === 'DRAFT')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                              type: "button",
                              onClick: ($event: any) => (toggleActionsMenu(repayment, $event))
                            }, [...(_cache[14] || (_cache[14] = [
                              _createElementVNode("i", { class: "flaticon-dots" }, null, -1)
                            ]))], 8, _hoisted_35))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
              (openMenuCode.value)
                ? (_openBlock(), _createElementBlock("ul", {
                    key: 0,
                    class: "dropdown-menu show custom-actions-menu",
                    style: _normalizeStyle({ top: menuPosition.top + 'px', left: menuPosition.left + 'px' })
                  }, [
                    (currentRepayment.value?.status==='DRAFT' && _unref(current_permissions)('status_repayment'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            style: {"color":"red"},
                            href: "javascript:void(0);",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (onActionClick('REJECTED')))
                          }, [
                            _cache[15] || (_cache[15] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('repayments.reject')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (currentRepayment.value?.status==='DRAFT' && _unref(current_permissions)('status_repayment'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_37, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            style: {"color":"green"},
                            href: "javascript:void(0);",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (onActionClick('VALIDATED')))
                          }, [
                            _cache[16] || (_cache[16] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('repayments.validate')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!(currentRepayment.value?.status==='DRAFT' && _unref(current_permissions)('status_repayment')))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                          _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('repayments.noAction')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 4))
                : _createCommentVNode("", true)
            ])),
            (filteredTotal.value>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  (filteredTotal.value>pageSize.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_41, [
                        _createTextVNode(_toDisplayString(_ctx.$t('repayments.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_42, _toDisplayString(showingFrom.value) + "-" + _toDisplayString(showingTo.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('repayments.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_43, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('repayments.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (filteredTotal.value<=pageSize.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_44, [
                        _createTextVNode(_toDisplayString(_ctx.$t('repayments.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_45, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('repayments.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_46, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('repayments.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("nav", _hoisted_47, [
                    _createElementVNode("ul", _hoisted_48, [
                      ((page.value-1)>0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (goToPage(page.value-1))),
                              "aria-label": "Previous"
                            }, [...(_cache[17] || (_cache[17] = [
                              _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numPages.value, (numPage) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: numPage,
                          class: "page-item"
                        }, [
                          (numPage==page.value)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_50, _toDisplayString(numPage), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "page-link",
                                onClick: ($event: any) => (goToPage(numPage))
                              }, _toDisplayString(numPage), 9, _hoisted_51))
                        ]))
                      }), 128)),
                      ((page.value+1)<=numPages.value)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_52, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (goToPage(page.value+1))),
                              "aria-label": "Next"
                            }, [...(_cache[18] || (_cache[18] = [
                              _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(storeRepayment, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("h1", _hoisted_57, _toDisplayString(_ctx.$t('repayments.repaymentRequest')), 1),
              _cache[19] || (_cache[19] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("h6", _hoisted_60, _toDisplayString(_ctx.$t('repayments.balance')), 1),
                _createElementVNode("h6", _hoisted_61, _toDisplayString(collectBalance.value?.toLocaleString()) + " XOF", 1)
              ]),
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                    _createElementVNode("h6", _hoisted_63, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_64, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _createElementVNode("h6", _hoisted_66, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.$t('repayments.repaymentType')), 1),
                    _createElementVNode("select", {
                      name: "mode",
                      id: "mode",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleTypeChange,
                      required: ""
                    }, [
                      _createElementVNode("option", _hoisted_71, _toDisplayString(_ctx.$t('repayments.select')), 1),
                      _createElementVNode("option", _hoisted_72, _toDisplayString(_ctx.$t('repayments.bankAccount')), 1),
                      _createElementVNode("option", _hoisted_73, _toDisplayString(_ctx.$t('repayments.cryptoAccount')), 1)
                    ], 32)
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t('repayments.amount')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        onKeyup: handleAmountChange,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formValues.amount) = $event)),
                        type: "number",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['amount'] }]),
                        id: "lead-calendar",
                        placeholder: "2",
                        onBlur: _cache[6] || (_cache[6] = ($event: any) => (validate('amount')))
                      }, null, 34), [
                        [_vModelText, formValues.amount]
                      ]),
                      _createElementVNode("span", _hoisted_76, _toDisplayString(errorsBis['amount']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.$t('repayments.description')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formValues.description) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['description'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('repayments.descriptionPlaceholder'),
                        onBlur: _cache[8] || (_cache[8] = ($event: any) => (validate('description'))),
                        onKeyup: _cache[9] || (_cache[9] = ($event: any) => (validate('description')))
                      }, "                    ", 42, _hoisted_80), [
                        [_vModelText, formValues.description]
                      ]),
                      _createElementVNode("span", _hoisted_81, _toDisplayString(errorsBis['description']), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_82, [
              (_unref(current_permissions)('create_repayment'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_83, [
                    _cache[20] || (_cache[20] = _createElementVNode("i", {
                      class: "flaticon-plus position-relative ms-5 fs-12",
                      style: {"color":"#FFF"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('repayments.save')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _cache[21] || (_cache[21] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})